import { format } from 'date-fns';
import { toRefs, computed, getCurrentInstance } from '@vue/composition-api';

import { QueryDateValue, QueryParam, QuerySchema } from '../types';
import { convertSchemaTreeToMap } from '../common';
import { PATH_DELIMITER } from '../constants';

export interface UseSearchQueryParamProps {
  readonly param: QueryParam;
  readonly schema: QuerySchema;
}

export function useSearchQueryParam(props: UseSearchQueryParamProps) {
  const { param, schema } = toRefs(props);
  const vm = getCurrentInstance()!;
  const schemaAsMap = convertSchemaTreeToMap(schema.value);

  const queryParamLabels = computed((): string[] => {
    const paramPathAsArray = param.value.key.split(PATH_DELIMITER);
    const schemaItemPaths: string[] = [];
    let parentPath = '';

    for (const path of paramPathAsArray) {
      const fullPath = parentPath ? parentPath + PATH_DELIMITER + path : path;

      schemaItemPaths.push(fullPath);
      parentPath = fullPath;
    }

    return schemaItemPaths.map((path: string): string => {
      return vm.proxy.$t(schemaAsMap[path].label) as string;
    });
  });

  const dateFromLabel = computed((): string => {
    const content = { date: formatDate((param.value.value as QueryDateValue).from) };
    return vm.proxy.$t('HITL.common.search.date-range-from', content) as string;
  });

  const dateToLabel = computed((): string => {
    const content = { date: formatDate((param.value.value as QueryDateValue).to) };
    return vm.proxy.$t('HITL.common.search.date-range-to', content) as string;
  });

  const formatDate = (value: string | Date): string => {
    return format(new Date(value), 'dd MMM y HH:mm');
  };

  return {
    schemaAsMap,
    queryParamLabels,
    dateFromLabel,
    dateToLabel,
  };
}
